import { render, staticRenderFns } from "./CoTextArea.vue?vue&type=template&id=6c6117c4&scoped=true&"
import script from "./CoTextArea.vue?vue&type=script&lang=js&"
export * from "./CoTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6117c4",
  null
  
)

export default component.exports